import React from "react";
import styled from "styled-components";

import wave from "./wave.png";

const Img = styled.img`
  margin: 0 0 30px 0;
`;

const RegisterSection = styled.section`
  background-color: #0a1936;
  color: #ffffff;
  padding-top: 220px;
  padding-bottom: ${(props) => (props.allowSubscriptions ? "70px" : "40px")};
  text-align: center;
`;

const H2 = styled.h2`
  color: rgb(255, 255, 255);
  display: block;
  font-family: europa;
  font-size: 53px;
  font-weight: 400;
  line-height: 63.6px;
  white-space: pre-wrap;
  margin: 0 0 10px 0;

  @media screen and (max-width: 850px) {
    font-size: 32px;
    line-height: 32px;
  }
`;

const Para = styled.p`
  margin: 0 0 20px 0;
  color: rgb(255, 255, 255);
  display: block;
  font-family: europa;
  font-size: 18px;
  font-weight: 400;
  line-height: 40px;
`;

const LinkButton = styled.a`
  background-color: rgb(248, 134, 99);
  color: rgb(255, 255, 255);
  display: inline-block;
  font-family: europa;
  font-size: 19px;
  font-weight: 700;
  letter-spacing: 0.07px;
  padding: 25px 46px;
  text-align: center;
  text-decoration: none;
  text-size-adjust: 100%;
  border-radius: 40px;
  margin: 0 0 0 0;

  @media screen and (max-width: 850px) {
    font-size: 16px;
    padding: 15px 26px 16px 26px;
  }
`;

const Register = ({ allowSubscriptions = true }) => {
  return (
    <RegisterSection allowSubscriptions={allowSubscriptions}>
      <Img src={wave} alt="Are you a business in the Manly area?" />
      <H2>Are you a business in the Manly area?</H2>
      <Para>
        Register here to let people know what you’re offering
        <br />
        (We’re planning to roll out in other areas soon. You can pre-register
        your interest here, too).
      </Para>
      <LinkButton href="https://forms.gle/U9tVvQoV2dMWNTTk7">
        Register your business
      </LinkButton>
    </RegisterSection>
  );
};

export default Register;
